import EventEmitter from 'eventemitter3'

const appEventEmitter = new EventEmitter()

export default appEventEmitter
